import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { downgradePlan } from '~/redux/actions/stripe-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';
import { getUserData } from '~/redux/actions/auth-actions';

//Utils
import { balanceFormatter } from '~/utils/helperFunctions';
import { MESSAGES } from '~/utils/message';
import ConfirmModal from '~/components/General/ConfirmModal';

//MUI Component
import Typography from '@mui/material/Typography';
import { Box, Grid } from '@mui/material';

// Icons
import { DowngradeCIcon, CrossPlansCIcon } from '~/assets/images';

// styles
import './styles.scss';

const DowngradeModal = (props) => {
  const { handleClose, open, selectedPlan, currentPlanDetails, planDetails } = props;
  const [requestLoader, setRequestLoader] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setRequestLoader(true);
      const response = await downgradePlan({ planId: selectedPlan.stripeId });
      if (response.status === 200) {
        dispatch(getUserData());
        dispatch(success(response?.data?.message));
        handleClose();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setRequestLoader(false);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open,
        header: MESSAGES.ACCOUNT.PLANS.DOWNGRADE.TITLE,
        icon: DowngradeCIcon,
        className: 'downgradeConfirmModal',
        message: (
          <Box className="downgradePlanSummary">
            <Typography className="downgradePlanName">{selectedPlan.name}</Typography>
            <Typography className="downgradePlanPrice">
              {selectedPlan?.billMonthly === 'Free' || selectedPlan?.amount === '0.00' ? (
                'Free'
              ) : (
                <>
                  {balanceFormatter(selectedPlan.amount)}/{selectedPlan.isYearly ? 'yr' : 'month'}
                </>
              )}
            </Typography>
          </Box>
        ),
        bodyContent: (
          <Box className="downgradeDetails">
            <Typography className="downgradeDescription">
              You will not be billed today. Your plan will downgrade on{' '}
              {planDetails?.planRenewsAt || ''}. After that
              {selectedPlan?.billMonthly === 'Free' || selectedPlan?.amount === '0.00'
                ? ', you will not be billed.'
                : ', you will be billed ' +
                  balanceFormatter(selectedPlan.amount) +
                  (selectedPlan.isYearly ? ' every year.' : ' every month.')}
            </Typography>
            <Box className="featureWrapper">
              <Typography>{MESSAGES.ACCOUNT.PLANS.DOWNGRADE.HEADING}</Typography>
              <Grid container spacing={2}>
                {Object.keys(currentPlanDetails?.features || {}).map((feature) => {
                  const currentFeature = currentPlanDetails?.features?.[feature] || {};
                  const selectedFeature = selectedPlan?.features?.[feature] || {};

                  const currentLimit = currentFeature.limit || 0;
                  const selectedLimit = selectedFeature.limit || 0;

                  if (
                    currentFeature.title &&
                    currentLimit !== 0 &&
                    selectedLimit !== -1 &&
                    currentLimit - selectedLimit !== 0
                  ) {
                    let limitText = '';
                    if (currentLimit === -1) {
                      limitText = 'Unlimited';
                    } else if (Math.abs(currentLimit - selectedLimit) !== 1) {
                      limitText = Math.abs(currentLimit - selectedLimit) + ' ';
                    }

                    return (
                      <Grid item sm={6} xs={12} key={feature}>
                        <Box className="featuresList">
                          <img src={CrossPlansCIcon} alt="" />
                          <Typography>
                            {limitText}
                            {currentFeature.title}
                          </Typography>
                        </Box>
                      </Grid>
                    );
                  }

                  return null;
                })}
              </Grid>
            </Box>
            {planDetails?.planDifference?.length > 0 && (
              <Box className="downgradeInfo">
                <Typography>
                  {MESSAGES.ACCOUNT.PLANS.DOWNGRADE.NOTE}
                  {planDetails?.planRenewsAt || ''}:
                </Typography>
                <ul>
                  {planDetails.planDifference.map((difference, index) => (
                    <li key={`${difference}-${index}`}>{difference}</li>
                  ))}
                </ul>
              </Box>
            )}
          </Box>
        ),
        loading: requestLoader,
        successButtonName: MESSAGES.ACCOUNT.PLANS.DOWNGRADE.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.ACCOUNT.PLANS.DOWNGRADE.CANCEL_BUTTON,
        handleOk: onSubmit,
        handleClose,
      }}
    />
  );
};

export default DowngradeModal;
